module.exports = __webpack_public_path__ + "img/Halloween Costume Bingo 2019.cfa3f60f.jpeg";